/* eslint-disable import/no-mutable-exports */
import { configureApiClient, configureApiClientV2 } from "@/core/services";

export let localhost: string | null = null;
export let apiUrl: string | null = null;

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();
  localhost = config.public.baseUrl as string | null;
  apiUrl = config.public.apiBaseUrl as string | null;
  configureApiClient();
  configureApiClientV2();
});
